namespace $ {

	export class $shm_hitalama_extension extends $giper_baza_entity.with({

		Site: $giper_baza_atom_text,

	}){

	}

}
